import React from "react"
import Header from "./Header/Header"
import { HeaderWave } from "components/Elements/Illustrations"
import Footer from "./Footer/Footer"
import { useOperator, usePageReducer } from "hooks"
import { BICYCODE_ID } from "operators/bicycode/config"

type PrivateLayoutProps = {
	children?: React.ReactNode
	className?: string
}

const PrivateLayout: React.FC<PrivateLayoutProps> = ({ children, className }) => {
	const { dispatchPageIsComplete, isComplete } = usePageReducer()
	const { currentOperator, isOperatorComplete } = useOperator()

	React.useEffect(() => {
		if (currentOperator && isOperatorComplete) dispatchPageIsComplete()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [currentOperator, isOperatorComplete])

	return (
		<>
			{isComplete && (
				<div
					className={`min-h-screen relative flex flex-col max-w-full overflow-x-hidden ${
						className || ""
					}`}
				>
					{currentOperator.id === BICYCODE_ID && (
						<HeaderWave className="absolute top-0 left-0" />
					)}
					<Header />
					<main role="main" className="flex-1 relative">
						{children}
					</main>

					<Footer className="md:px-14 pb-6 py-8 c-footer__with-bkg" />
				</div>
			)}
		</>
	)
}

export default PrivateLayout
